const alphaMatch = /[a-zA-Z]/;
const specialCharacterMatch = /[^a-zA-Z0-9 ]/;
const lowerCaseMatch = /[a-z]/;
const upperCaseMatch = /[A-Z]/;
const invalidCharacters = /[| ]/;

export function getPasswordErrors(password, rules) {
    const errors = [];

    if (password.length < rules.minimum_password_length) {
        errors.push('minimum_password_length');
    }

    let characterCount = 0;
    let specialCharacterCount = 0;
    let upperCaseLetterCount = 0;
    let lowerCaseLetterCount = 0;

    let hasInvalidCharacters = false;

    for (let char of password) {

        if (char.match(invalidCharacters)) {
            hasInvalidCharacters = true;
        }

        characterCount += char.match(alphaMatch) ? 1 : 0;
        specialCharacterCount += char.match(specialCharacterMatch) ? 1 : 0;
        upperCaseLetterCount += char.match(upperCaseMatch) ? 1 : 0;
        lowerCaseLetterCount += char.match(lowerCaseMatch) ? 1 : 0;
    }

    if (hasInvalidCharacters) {
        errors.push('invalid_characters');
    }

    if (characterCount < rules.password_min_alphanumeric) {
        errors.push('password_min_alphanumeric');
    }

    if (specialCharacterCount < rules.password_min_special_characters) {
        errors.push('password_min_special_characters');
    }

    if (upperCaseLetterCount < rules.password_min_upper_case_letters) {
        errors.push('password_min_upper_case_letters');
    }

    if (lowerCaseLetterCount < rules.password_min_lower_case_letters) {
        errors.push('password_min_lower_case_letters');
    }

    return errors;
}